import { render, staticRenderFns } from "./Leistungen.vue?vue&type=template&id=446810d0&"
import script from "./Leistungen.vue?vue&type=script&lang=js&"
export * from "./Leistungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Leistungen.vue"
export default component.exports